export const dataTableCustomNumberFormat = <T>(selector: string, decimals: number) => (row: T) => {
    const value = (row as any)[selector];

    if (isNaN(value)) {
        console.warn('Item is not a number and cannot be formatted.', { row, selector, value });
        return value;
    }
    return value.toFixed(decimals);
}

export const dataTableYesNoFromBooleanFormatter = <T>(selector: string) => (row: T) => {
    const value = (row as any)[selector];

    return yesNoFromBooleanFormatter(value)
}

export const yesNoFromBooleanFormatter = (value: any) => {

    if (value == null || value === 0) return "No";
    if (value === true || value === 1) return "Yes";

    return "No";
}

